import { DefaultError, useInfiniteQuery } from '@tanstack/react-query';
import { useInfiniteHandler } from 'hooks';
import { IContractProduct } from 'services/contract/types';
import { IInfinitePageParams, IInfinitePageResponse } from 'services/types';
import { apiClient } from 'utils';
import { getDefaultInfinitePageParam } from 'utils/service/defaultInfinitePageParam';
import { useResponseHandler } from 'utils/service/responseHandler';
import { IArtistTrack } from './types';

// export const useGetArtistProducts = () => {
//   const { responseHandler } = useResponseHandler();
//   return useQuery<IContractProduct[], DefaultError>({
//     queryKey: ['artist-products'],
//     async queryFn() {
//       const response = await apiClient({
//         method: 'GET',
//         url: `Artist/Products`,
//       });

//       return responseHandler(response, {
//         groupName: `useGetArtistProducts`,
//       });
//     },
//   });
// };

export const useGetArtistProductsInfinite = (
  id: string,
  params?: IInfinitePageParams
) => {
  const { responseHandler } = useResponseHandler();
  const { getNextPageParam, infiniteHandler } = useInfiniteHandler();

  const { itemCount, page } = getDefaultInfinitePageParam(
    params?.page,
    params?.itemCount
  );

  return useInfiniteQuery<IContractProduct[], DefaultError>({
    queryKey: ['artist-products-infinite', id, params],
    queryFn: async ({ pageParam }) => {
      const response = await apiClient({
        method: 'GET',
        url: 'Artist/Products',
        params: {
          ArtistId: id,
          //   ...JSON.parse(JSON.stringify(params)),
          ...params,
          itemCount,
          page: pageParam,
        },
      });

      const value = await responseHandler<
        IInfinitePageResponse<IContractProduct>
      >(response, {
        groupName: `useGetArtistProductsInfinite - ${pageParam}`,
      });

      return infiniteHandler<IContractProduct>(value);
    },
    initialPageParam: page,
    getNextPageParam: getNextPageParam,
    // enabled: !!id,
    retry: false,
  });
};

export const useGetArtistTracksInfinite = (
  id: string,
  params?: IInfinitePageParams
) => {
  const { responseHandler } = useResponseHandler();
  const { getNextPageParam, infiniteHandler } = useInfiniteHandler();

  const { itemCount, page } = getDefaultInfinitePageParam(
    params?.page,
    params?.itemCount
  );

  return useInfiniteQuery<IArtistTrack[], DefaultError>({
    queryKey: ['artist-tracks-infinite', id, params],
    queryFn: async ({ pageParam }) => {
      const response = await apiClient({
        method: 'GET',
        url: 'Artist/Tracks',
        params: {
          ArtistId: id,
          //   ...JSON.parse(JSON.stringify(params)),
          ...params,
          itemCount,
          page: pageParam,
        },
      });
      const value = await responseHandler<IInfinitePageResponse<IArtistTrack>>(
        response,
        {
          groupName: `useGetArtistTracksInfinite - ${pageParam}`,
        }
      );

      return infiniteHandler<IArtistTrack>(value);
    },
    initialPageParam: page,
    getNextPageParam: getNextPageParam,
    // enabled: !!id,
    retry: false,
  });
};
